export type { Language, Translations } from './types';
export { LANGUAGES, DEFAULT_LANGUAGE } from './types';
export { DATE_LOCALES, dateLocale } from './locale';
export { resolveUserLanguage, storedSessionLanguage } from './resolveLanguage';
export { tf } from './format';
export { en } from './en';
export { nl } from './nl';
export { fr } from './fr';
export { de } from './de';

import type { Language, Translations } from './types';
import { en } from './en';
import { nl } from './nl';
import { fr } from './fr';
import { de } from './de';

export const translations: Record<Language, Translations> = { en, nl, fr, de };
